import type { RechercheAnomaliesResponse } from './types';

const base = { credentials: 'include' as RequestCredentials };

export async function fetchEngins(): Promise<unknown[]> {
  const r = await fetch('/api/inventaires/engins', base);
  if (r.status === 403) return [];
  return r.ok ? r.json() : [];
}

export async function fetchTypes(): Promise<unknown[]> {
  const r = await fetch('/api/inventaires/types', base);
  if (r.status === 403) return [];
  return r.ok ? r.json() : [];
}

export async function fetchInventaires(date: string): Promise<unknown[]> {
  const r = await fetch(`/api/inventaires?date=${encodeURIComponent(date)}`, base);
  if (r.status === 403) return [];
  return r.ok ? r.json() : [];
}

export async function fetchSignatures(date: string): Promise<{ engin_ids?: (string | number)[]; details?: Record<string, { signataire_nom?: string }> }> {
  const r = await fetch(`/api/inventaires/signatures?date=${encodeURIComponent(date)}`, {
    ...base,
    cache: 'no-store',
  });
  if (r.status === 403 || !r.ok) return { engin_ids: [] };
  return r.json();
}

export async function fetchRechercheAnomalies(
  q: string,
  limit = 50,
  offset = 0,
): Promise<RechercheAnomaliesResponse> {
  const params = new URLSearchParams({
    q,
    limit: String(limit),
    offset: String(offset),
  });
  const r = await fetch(`/api/inventaires/recherche-anomalies?${params}`, base);
  if (r.status === 403) return { total: 0, items: [] };
  if (!r.ok) {
    const body = await r.json().catch(() => ({}));
    throw new Error((body as { error?: string }).error || 'Erreur recherche');
  }
  return r.json();
}
